import React, { useState } from "react";
import { Link } from "react-router-dom";
import Home from "../Home/Home";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import { useHistory } from "react-router-dom";
import { Home_page } from "../Constant/Constants";
import { useTranslation } from "react-i18next";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Login() {
  //storing the usehistory method in history variable
  let history = useHistory();
  let { t } = useTranslation();

  //state for email and password
  const [uname, setUname] = useState("");
  const [pass, setPass] = useState("");

  //onchange method for email
  const handleLogChange = (event) => {
    setUname(event.target.value);
  };

  //
  const handleLog2Change = (event) => {
    setPass(event.target.value);
  };
  const handleInputClick = () => {
    if (uname.length > 0 && pass.length > 0) {
      history.push(Home_page);
    } else {
      {
        toast.error('Please fill the details', {
          position: "top-center",
        });
      }
    }
  };

  return (
    <>
      <div className="login" >
        {/* login form */}
        <form >
          <div className="mb-3">
            <label
              for="exampleInputEmail1"
              className="form-label"
              style={{
                fontSize: "15px",
                fontFamily: "cursive",
                color: "orangered",
                marginTop: "30px",
              }}
            >
              {t("email")}
            </label>
            <input
              onChange={handleLogChange}
              style={{ width: "200px", margin: "auto", outline: "none" }}
              type="email"
              className="form-control"
              id="exampleInputEmail1"
              value={uname}
              aria-describedby="emailHelp"
              placeholder={t("p_email")}
              required
            />
            {/* <div id="emailHelp" className="form-text">
              We'll never share your email with anyone else.
            </div> */}
          </div>
          <div className="mb-3">
            <label
              for="exampleInputPassword1"
              className="form-label"
              style={{
                fontSize: "17px",
                fontFamily: "cursive",
                color: "orangered",
                marginTop: "20px",
              }}
            >
              {t("pass")}
            </label>
            <input
              onChange={handleLog2Change}
              style={{ width: "200px", margin: "auto", outline: "none" }}
              type="password"
              value={pass}
              className="form-control"
              id="exampleInputPassword1"
              placeholder={t("p_pass")}
              required
            />
          </div>
          {/* <div className="mb-3 form-check">
            <input
              type="checkbox"
              className="form-check-input"
              id="exampleCheck1"
            />
            <label className="form-check-label" for="exampleCheck1">
              Check me out
            </label>
          </div> */}
          <button
            // onClick={() => {
            //   history.push(Home_page)}}
            onClick={handleInputClick}
            type="submit"
            className="btn btn-danger"
          >
            {t("submit")}
          </button>

          {/* <input type="submit"/> */}
        </form>
        {/* login form */}
        {/* <div>
        <h1>Login</h1>
      </div> */}
        {(isLoggedin) => {
          {
            <>
              {isLoggedin ? (
                <>
                  <Link to={Home_page}>
                    <Home />
                  </Link>
                </>
              ) : (
                "lkkk"
              )}
            </>;
          }
        }}
      </div>
      <ToastContainer />
    </>
  );
}
